import React from 'react';
import { CustomizationChoice } from '@hexcrawl/shared-utils';

interface Props {
  choices: CustomizationChoice[];
  selected: string; // choiceId
  onChange: (choiceId: string) => void;
}

export const PartIconSelector: React.FC<Props> = ({ choices, selected, onChange }) => {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
      {choices.map((choice) => (
        <button
          key={choice.id}
          onClick={() => onChange(choice.id)}
          style={{
            padding: '4px 10px',
            borderRadius: 4,
            border: selected === choice.id ? '2px solid #4CAF50' : '2px solid #555',
            background: selected === choice.id ? '#1f3d1f' : '#2a2a3e',
            color: selected === choice.id ? '#fff' : '#aaa',
            cursor: 'pointer',
            fontSize: 13,
          }}
        >
          {choice.label}
        </button>
      ))}
    </div>
  );
};
